import createIcon from '../../createIcon';

/**
 * @component @name AllInbox
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxMkMzIDEzLjEgMy45IDE0IDUgMTRIMTlDMjAuMSAxNCAyMSAxMy4xIDIxIDEyVjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xOSA5SDE1QzE1IDEwLjYyIDEzLjYyIDEyIDEyIDEyQzEwLjM4IDEyIDkgMTAuNjIgOSA5SDVWNUgxOVY5Wk0xNSAxNkgyMVYxOUMyMSAyMC4xIDIwLjEgMjEgMTkgMjFINUMzLjkgMjEgMyAyMC4xIDMgMTlWMTZIOUM5IDE3LjY2IDEwLjM0IDE5IDEyIDE5QzEzLjY2IDE5IDE1IDE3LjY2IDE1IDE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AllInbox = createIcon('AllInbox', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V12C3 13.1 3.9 14 5 14H19C20.1 14 21 13.1 21 12V5C21 3.9 20.1 3 19 3ZM19 9H15C15 10.62 13.62 12 12 12C10.38 12 9 10.62 9 9H5V5H19V9ZM15 16H21V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V16H9C9 17.66 10.34 19 12 19C13.66 19 15 17.66 15 16Z',
      key: '195arp',
    },
  ],
]);

export default AllInbox;
